import { Button, Collapse, Space, Table, Typography } from "antd";
import { observer } from "mobx-react-lite";
import storeStorage, { ICurrentStoreItem } from "../../storages/store.storage";
import { useEffect } from "react";
import ordersStorage from "../../storages/orders.storage";

export function StorePage() {
  // const { items, isDialogOpened, toggleDialog, loadItems } = storeStorage;
  const { loadOrders, groupedItems_v2 } = ordersStorage;
  const { isDetailDialogOpened, toggleDetailDialog } = storeStorage;

  useEffect(() => {
    // loadItems();
    loadOrders();
  }, []);

  return (
    <div>
      <Space>
        {/*<Button type="primary" onClick={toggleDialog}>Add</Button>*/}
      </Space>
      <Space>
        <Typography.Text>Total: {groupedItems_v2.total?.toFixed(2)}</Typography.Text>
        <Typography.Text>Economy: {groupedItems_v2.totalEconomy?.toFixed(2)}</Typography.Text>
      </Space>
      <div style={{width: '100%'}}>
        {Object.keys(groupedItems_v2.items)
          .sort((a, b) => a.localeCompare(b))
          .map((key) => {
          return (
            <Space direction={"vertical"} style={{width: '100%'}}>
              {key}
              <Space wrap={true} direction="vertical">
                {Object.keys(groupedItems_v2.items[key])
                  .sort((a, b) => a.localeCompare(b))
                  .map((innerKey) => {
                    const qty = Object.entries(groupedItems_v2.items[key][innerKey]).reduce((acc, [name, data]) => acc + data.qty, 0);
                  return (
                    <Collapse>
                      <Collapse.Panel key={innerKey} header={`${innerKey} - ${qty}`}>
                        <Table
                          columns={[
                            {
                              title: "name",
                              dataIndex: "name",
                              key: "name",
                            },
                            {
                              title: "orderedQty",
                              dataIndex: "orderedQty",
                              key: "orderedQty",
                            },
                            {
                              title: "qty",
                              dataIndex: "qty",
                              key: "qty",
                            },
                            {
                              title: "variants",
                              dataIndex: "variants",
                              key: "variants",
                            },
                            {
                              title: "partTypes",
                              dataIndex: "partTypes",
                              key: "partTypes",
                              render: (value, rowData) => JSON.stringify(rowData.partTypes),
                            },
                            {
                              title: "actions",
                              dataIndex: "actions",
                              key: "actions",
                              render: (value, item: ICurrentStoreItem) => (
                                <Space>
                                  <Button type="primary" onClick={() => toggleDetailDialog(item)}>Details</Button>
                                </Space>
                              ),
                            }
                          ]}
                          pagination={{
                            pageSize: 100,
                          }}
                          dataSource={Object
                            .entries(groupedItems_v2.items[key][innerKey])
                            .sort(([a], [b]) => a.localeCompare(b))
                            .map(([name, data]) => {
                            return {
                              name,
                              qty: data.qty,
                              orderedQty: data.orderedQty,
                              variants: [...data.variants].join(', '),
                              cost: data.cost?.toFixed(2),
                              partTypes: data.partTypes,
                            }
                          })}
                        />
                      </Collapse.Panel>
                    </Collapse>
                  )
                })}
              </Space>
            </Space>
          )
        })}
      </div>
      {/*<AddStoreVariantDialog opened={isDialogOpened} onToggle={toggleDialog} />*/}
      {/*<DetailStoreVariantDialog opened={isDetailDialogOpened} onToggle={() => toggleDetailDialog()} />*/}
    </div>
  );
}

export default observer(StorePage);
